import { Field, useField, useForm } from "react-final-form"
import "react-phone-input-2/lib/plain.css"

import {
  composeValidators,
  mustBePhoneNumber,
  required,
} from "@trueskin-web/functions"
import { getCountry } from "@trueskin-web/locales"
import { useTranslation } from "@trueskin-web/translations"

import PhoneNumberInput from "./phone-number-input"

const preferredCountries = ["de", "ch"]

const PhoneNumber = ({ fieldName }) => {
  const { t } = useTranslation()
  const phoneNumberField = useField(fieldName)
  const form = useForm()

  const country = getCountry().toLocaleLowerCase()

  const formatPhoneNumber = (value) => `+${value}`

  const handleFieldClear = () => {
    form.resetFieldState(fieldName)
    form.change(fieldName, "")
  }

  return (
    <Field
      dataTestId="web-portal-shipping-form-phone-number"
      label={t("Start.Questionnaire.phoneNumber")}
      placeholder={t("Start.Questionnaire.phoneNumber")}
      name={fieldName}
      country={country}
      preferredCountries={preferredCountries}
      countryCodeEditable={false}
      component={PhoneNumberInput}
      required
      validate={composeValidators(
        (value) => required(value, t("Generic.errors.phoneNumberRequired")),
        mustBePhoneNumber
      )}
      message={t("Start.Questionnaire.phoneNumberHint")}
      parse={formatPhoneNumber}
      format={formatPhoneNumber}
      clearable={Boolean(phoneNumberField.input.value)}
      onClear={() => handleFieldClear()}
    />
  )
}

export default PhoneNumber
